import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../lib/utils";

export const Button = React.forwardRef(function Button(
  { className, variant = "default", size = "md", asChild = false, ...props },
  ref
) {
  const Comp = asChild ? Slot : "button";
  const variants = {
    default:
      "bg-[hsl(var(--primary))] text-[#0b1220] hover:bg-[hsl(var(--primary-2))] active:scale-[0.98] shadow-[0_0_0_1px_hsl(var(--primary)/0.4),0_8px_28px_-12px_hsl(var(--primary)/0.5)]",
    secondary:
      "bg-[hsl(var(--bg-elev-2))] text-[hsl(var(--fg))] border border-[hsl(var(--border))] hover:bg-[hsl(var(--bg-elev-1))]",
    ghost:
      "bg-transparent text-[hsl(var(--fg))] hover:bg-[hsl(var(--bg-elev-2))]",
    danger:
      "bg-[hsl(var(--danger)/0.12)] text-[hsl(var(--danger))] border border-[hsl(var(--danger)/0.4)] hover:bg-[hsl(var(--danger)/0.18)]",
    outline:
      "bg-transparent border border-[hsl(var(--border))] text-[hsl(var(--fg))] hover:bg-[hsl(var(--bg-elev-2))]",
  };
  const sizes = {
    sm: "h-8 px-3 text-xs rounded-md",
    md: "h-10 px-4 text-sm rounded-lg",
    lg: "h-12 px-5 text-base rounded-lg",
    icon: "h-9 w-9 rounded-md inline-flex items-center justify-center",
  };
  return (
    <Comp
      ref={ref}
      className={cn(
        "inline-flex items-center justify-center gap-2 font-medium transition-[background-color,transform,box-shadow,border-color,color] duration-150 ease-out outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] focus-visible:ring-offset-2 focus-visible:ring-offset-[hsl(var(--bg))] disabled:opacity-50 disabled:pointer-events-none",
        variants[variant] || variants.default,
        sizes[size] || sizes.md,
        className
      )}
      {...props}
    />
  );
});
